// CHANGE THIS FUNCTION INTO A FW CLASS
/*
*   Function to get normal forces of strut and tie model
*   @Input:     nodes - Array of objects    {x: Number, y: Number}
*   @Input:     struts - Array of objects   {node1: Number, node2: Number}
*   @Input:     forces - Array of objects   {node: Number, fx: Number, fy: Number}
*   @Input:     supports - Array of objects {node: Number, dir: String} (dir: x,y (blocked))
*   @Return:    strut and support forces - Array of numbers -> [N_strut1, N_strut2, ..., F_support1, F_support2, ...] 
*/
function fwSolver (nodes, struts, supports, forces) {

    // Check stat Bestimmtheit...

    let k = nodes.length;
    let l = supports.length;
    let s = struts.length;

    if (2*k-(s+l) === 0) {
    
        let eq = math.zeros(2*k, 2*k);
        let fr = math.zeros(2*k);

        // Generate all equations and write into matrix eq...
        nodes.forEach((node, nodeKey) => {
            // Add equation...
            let elm = struts.filter(strut => (strut.node1 === nodeKey || strut.node2 === nodeKey));
            elm.forEach((str) => {
                let pos = struts.indexOf(str);

                // Calc lengths
                let dx = nodes[str.node2].x - nodes[str.node1].x;
                let dy = nodes[str.node2].y - nodes[str.node1].y;
                
                if ( str.node1 !== nodeKey ) {
                    dx = -dx;
                    dy = -dy;
                }

                let alpha = math.atan2(dy,dx);

                eq._data[nodeKey*2][pos] = -math.cos(alpha);   // In x-direction
                eq._data[nodeKey*2+1][pos] = -math.sin(alpha); // In y-direction
            })
        });

        supports.forEach((sup, supKey) => {
            // Add supports...
            if(sup.dir === 'x') {
                eq._data[sup.node*2][struts.length+supKey] = -1;
            } else {
                eq._data[sup.node*2+1][struts.length+supKey] = -1;
            }
        });

        forces.forEach((frc) => {
            fr._data[frc.node*2]    = frc.fx;
            fr._data[frc.node*2+1]  = frc.fy;
        });

        /*console.log(eq._data);
        console.log(math.print("$eq", {eq: eq}));
        console.log(math.print("$fr", {fr: fr}));*/

        let solution = math.lusolve(eq,fr);

        //Round solution...
        solution = math.round(solution, 3);

        /*console.log(math.print("$sl", {sl: solution}));*/

        // Flatten matrix to array...
        return math.flatten(solution)._data;
    } else {
        console.log('Statisch unbestimmtes oder unterbestimmtes System!');
    }
}